import { useState, useEffect } from "react";
import { useGetAllChaptersQuery } from "src/services/ChapterServices";

const useChapters = () => {
  const [chapters, setChapters] = useState<any[]>([]);
  const [isDataLoading, setIsDataLoading] = useState(true);

  const { data, isLoading, isFetching } = useGetAllChaptersQuery("");

  useEffect(() => {
    if (isLoading || isFetching) {
      setIsDataLoading(true);
    } else {
      const result: any[] = data?.data;
      setChapters(result || []);
      setIsDataLoading(false);
    }
  }, [data, isLoading, isFetching]);

  return { chapters, isDataLoading };
};

export default useChapters;
